// extracted by mini-css-extract-plugin
module.exports = {"form":"Checkout_form__3ok3_","control":"Checkout_control__1W_oU","actions":"Checkout_actions__LtWbt","submit":"Checkout_submit__3oMM-","invalid":"Checkout_invalid__3Fhj3"};